import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import ThemeSlider from "./ThemeSlider";
import { Link } from "react-router-dom";
import { Divider } from "@mui/material";

const pages = [
  {
    name: "Home",
    path: "/",
  },
  {
    name: "Download",
    path: "/download",
  },
  {
    name: "Our Teams",
    path: "/teams",
  },
  {
    name: "Gallery",
    path: "/gallery",
  },
  {
    name: "About",
    path: "/about",
  },
  {
    name: "Contact Us",
    path: "/contact",
  },
];

function Header({ darkThemeStatus, setDarkThemeStatus }) {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleThemeChange = () => {
    console.log("Button is clicked");
    handleCloseNavMenu();
    if (darkThemeStatus) {
      document.body.style.backgroundColor = "#f9f3ee";
    } else {
      document.body.style.backgroundColor = "#212121";
    }
    setDarkThemeStatus(!darkThemeStatus);
  };

  return (
    <AppBar>
      <Container maxWidth="xl" sx={{ fontWeight: "800" }}>
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              textDecoration: "none",
            }}
          >
            <img
              src="/Images/Logo.jpg"
              style={{
                borderRadius: "50%",
                height: "80px",
                width: "80px",
              }}
              alt="logo"
            />
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <Link key={page.name} to={page.path}>
                  <MenuItem onClick={handleCloseNavMenu}>
                    <Typography textAlign="center" style={{ color: "black" }}>
                      {page.name}
                    </Typography>
                  </MenuItem>
                  <Divider />
                </Link>
              ))}
              <MenuItem>
                <ThemeSlider onClick={handleThemeChange} />
              </MenuItem>
            </Menu>
          </Box>

          <Typography
            variant="h5"
            noWrap
            component="a"
            href=""
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            <img
              src="/Images/Logo.jpg"
              style={{
                borderRadius: "50%",
                height: "80px",
                width: "80px",
              }}
              alt="logo"
            />
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <Link key={page.name} to={page.path}>
                <Button
                  key={page.name}
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, fontWeight: "800", display: "block" }}
                >
                  <Typography variant="body1" textAlign="center">
                    {page.name}
                  </Typography>
                </Button>
              </Link>
            ))}
            <MenuItem>
              <ThemeSlider onClick={handleThemeChange} />
            </MenuItem>
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Link to={`/dashboard`}>
              <Button
                variant="contained"
                color="bgButtonPrimary"
                sx={{
                  m: 1,
                  p: 1.5,
                  fontWeight: "800",
                }}
              >
                Admin Login
              </Button>
            </Link>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Header;
